import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ESaveSearchActionType } from './types';

export const openSaveSearchModal = actionGenerator<ESaveSearchActionType.ModalOpened>(
  ESaveSearchActionType.ModalOpened,
);
